// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse {
    static getAttributeTypeMap() {
        return CouponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse.attributeTypeMap;
    }
}
CouponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse.discriminator = undefined;
CouponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse.additionalProperties = false;
CouponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtEnrollmentResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=couponEnrollmentEnrollmentWithInsuranceProgramIdEnrollmentWithInsuranceResponse.js.map